import React, { useEffect, useRef, useState } from "react";
import {
  ButtonCancel,
  ButtonCreate,
  ContentButtons,
  ContentFields,
  ContentFile,
  FieldFile,
  GeneralStyle,
} from "./CreateSpaceComponent.styled";
import { NotificationManager } from "react-notifications";
import PersonIcon from "@material-ui/icons/Person";
import RenderInputsComponent from "../RenderInputsComponent/RenderInputsComponent";
import FileUpload from "../FileUpload";
import InviteUsersGroupsContainer from "../../containers/InviteUsersGroupsContainer/InviteUsersGroupsContainer";
import moment from "moment";
import { theme as themeConfig } from "../../themes/themes";

const CreateSpaceComponent = ({
  files,
  setFiles,
  loadingCoverImage,
  SpaceEdit,
  createNew,
  updateOld,
  action,
  goToBackPage,
  setCountryId,
  countries,
  cities,
  rCity,
}) => {
  const rName = useRef();
  const rTopic = useRef();
  const rCountry = useRef();
  const rDescription = useRef();
  const rUrl = useRef();
  const rInitialDate = useRef();
  const rFinishDate = useRef();
  const [usersSelection, setUsersSelection] = useState([]);
  const [groupsSelection, setGroupsSelection] = useState([]);
  const [, setDataBulkUpload] = useState([]);
  const [RenderAgain, setRenderAgain] = useState(false);
  const [editData, setEditData] = useState([]);
  const [usersSelected, setUsersSelected] = useState([]);
  const [groupsSelected, setGroupsSelected] = useState([]);

  const [groupDeleted, setGroupDeleted] = useState([]);
  const [usersDeleted, setUserDeleted] = useState([]);

  const [folderName] = useState("Spaces");

  useEffect(() => {
    if (rCountry.current.state.ariaSelection?.value) {
      setCountryId(rCountry.current.state.ariaSelection.value?.value);
    }
    if (rCity.current) {
      rCity.current.clearValue();
    }
  }, [rCountry?.current?.state?.ariaSelection]);

  useEffect(() => {
    if (SpaceEdit) {
      rName.current.value = SpaceEdit.name;
      rTopic.current.value = SpaceEdit.topic;
      rCountry.current.state.ariaSelection = {
        value: SpaceEdit.idCountry,
        label: SpaceEdit.countryName,
      };
      rCountry.current.state.selectValue = [
        {
          value: SpaceEdit.idCountry,
          label: SpaceEdit.countryName,
        },
      ];
      rUrl.current.value = SpaceEdit.url;
      const localStartDateTime = moment.utc(SpaceEdit.startDate).local().format("YYYY-MM-DDTHH:mm");
    rInitialDate.current.value = localStartDateTime;

    const localEndDateTime = moment.utc(SpaceEdit.finishDate).local().format("YYYY-MM-DDTHH:mm");
    rFinishDate.current.value = localEndDateTime;
     
      let usersSelected = SpaceEdit.wellnessSpacesSearchsResults.filter(
        (item) => {
          if (item.isGroup === false) {
            return {
              value: item.userId,
              label: item.name,
            };
          }
        }
      );
      setUsersSelection(usersSelected);
      let groupObj = {};
      SpaceEdit.wellnessSpacesSearchsResults.forEach((item) => {
        if (item.isGroup === true) {
          if (groupObj[item.name]) {
            groupObj[item.name].push(item.userId);
          } else {
            groupObj[item.name] = [item.userId];
          }
        }
      });
      let groupArr = [];
      for (let key in groupObj) {
        groupArr.push({
          value: key,
          userIds: groupObj[key],
          groupName: key,
        });
      }
      setGroupsSelection(groupArr);
      rDescription.current.value = SpaceEdit.description;
      setRenderAgain(!RenderAgain);
    }
  }, [SpaceEdit]);

  useEffect(() => {
    setEditData({
      guests: usersSelection,
      groups: groupsSelection,
    });
    setGroupsSelected(groupsSelection);
    setUsersSelected(usersSelection);
  }, [usersSelection, groupsSelection]);

  const executefn = () => {
    setTimeout(() => {
      setRenderAgain(!RenderAgain);
    }, 100);
  };

  let fields = [
    {
      type: "text",
      label: "Space Name",
      field: "name",
      ref: rName,
      fn: executefn,
      placeholder: "Type here",
      mandatory: true,
    },
    {
      type: "text",
      label: "Topic",
      field: "topic",
      ref: rTopic,
      fn: executefn,
      placeholder: "Type here",
      mandatory: true,
    },
    {
      type: "select",
      label: "Country",
      field: "country",
      ref: rCountry,
      fn: executefn,
      placeholder: "Select an option",
      data: countries,
      mandatory: true,
      isMulti: false,
    },
    {
      type: "select",
      label: "City",
      field: "city",
      ref: rCity,
      fn: executefn,
      placeholder: "Select an option",
      data: cities,
      mandatory: true,
      isMulti: false,
    },
    {
      type: "text",
      label: "Enter the URL of the event",
      field: "url",
      ref: rUrl,
      fn: executefn,
      placeholder: "Paste your Event URL here",
      mandatory: true,
    },
    {
      type: "datetime-local",
      label: "Initial Date",
      field: "startDate",
      ref: rInitialDate,
      fn: executefn,
      placeholder: "Select a initial date and time",
      mandatory: true,
    },
    {
      type: "datetime-local",
      label: "Finish Date",
      field: "finishDate",
      ref: rFinishDate,
      fn: executefn,
      placeholder: "Select a finish date and time",
      mandatory: true,
    },
    {
      type: "textarea",
      label: "Description",
      field: "description",
      ref: rDescription,
      fn: executefn,
      placeholder: "Please enter a description",
      mandatory: true,
    },
  ];

  const validateData = () => {
    let data = {};
    let missingData = false;
    let errorData = false;
    for (let index = 0; index < fields.length; index++) {
      if (!fields[index].mandatory) {
        data[fields[index].field] = fields[index].ref.current.value;
      } else if (
        fields[index].mandatory &&
        ((fields[index].type === "select" &&
          !fields[index].ref.current.state.ariaSelection) ||
          (fields[index].type === "select" &&
            fields[index].isMulti &&
            !fields[index].ref.current.state.selectValue.length) ||
          (fields[index].type === "text" &&
            fields[index].ref.current.value === "") ||
          (fields[index].type === "date" &&
            fields[index].ref.current.value === "") ||
          (fields[index].type === "datetime-local" &&
            fields[index].ref.current.value === "") ||
          (fields[index].type === "time" &&
            fields[index].ref.current.value === "") ||
          (fields[index].type === "number" &&
            fields[index].ref.current.value === "") ||
          (fields[index].type === "textarea" &&
            fields[index].ref.current.value === ""))
      ) {
        missingData = true;
        break;
      } else if (
        fields[index].field === "Email" &&
        fields[index].regexp &&
        (!fields[index].regexp.test(fields[index].ref.current.value) ||
          (fields[index].field !== "Email" &&
            fields[index].regexp &&
            fields[index].regexp.test(fields[index].ref.current.value)))
      ) {
        errorData = true;
        break;
      } else {
        data[fields[index].field] =
          fields[index].type === "select"
            ? fields[index].ref.current.state.ariaSelection
            : fields[index].ref.current.value;
      }
      if (index === fields.length - 1) {
        data["file"] = files.file;
      }
    }
    if (!missingData && !errorData) {
      if (action === "add")
        createNew(data, groupsSelected, usersSelected, folderName);
      else if (action === "edit") {
        updateOld(data, groupsSelected, usersSelected, folderName);
      }
      return;
    }
    if (errorData)
      NotificationManager.warning("there are errors in the fields", "", 5000);
    else if (missingData)
      NotificationManager.warning("Missing fields", "", 5000);
  };

  return (
    <GeneralStyle>
      <div
        style={{
          color: "rgb(123, 123, 123)",
          fontWeight: "700",
          fontSize: "18px",
          display: "flex",
          padding: "0 0 2em 0",
        }}
      >
        <PersonIcon style={{ color: themeConfig.neutral.gray[2600] }} />
        {action === "add" ? "Create" : "Edit"} Space
      </div>
      <ContentFields>
        <RenderInputsComponent fields={fields}></RenderInputsComponent>
        <FieldFile>
          <label>Cover image (Optional)</label>
          <ContentFile>
            <FileUpload
              accept=".jpg,.png,.jpeg"
              setDataBulkUpload={setDataBulkUpload}
              setFiles={setFiles}
              files={files}
              loadingImage={loadingCoverImage}
            />
          </ContentFile>
        </FieldFile>
      </ContentFields>

      <div>
        <InviteUsersGroupsContainer
          editData={editData}
          action={action}
          setUsersSelected={setUsersSelected}
          setGroupsSelected={setGroupsSelected}
          groupDeleted={groupDeleted}
          setGroupDeleted={setGroupDeleted}
          userDeleted={usersDeleted}
          setUserDeleted={setUserDeleted}
        />
      </div>

      <ContentButtons>
        <ButtonCancel onClick={() => goToBackPage()}>Cancel</ButtonCancel>
        <ButtonCreate
          onClick={() => {
            validateData();
          }}
        >
          {action === "add" ? "Create" : "Update"} Space
        </ButtonCreate>
      </ContentButtons>
    </GeneralStyle>
  );
};

export default CreateSpaceComponent;
